/* eslint-disable object-curly-newline */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-dracula';

import api from '~/services/api';
import history from '~/services/history';
import { Container, Row, Header, ButtonTest } from './styles';

export default function Challenges() {
  const [jobs, setJobs] = useState([]);
  const [feedback, setFeedback] = useState('');

  useEffect(() => {
    async function getData() {
      const { data } = await api.get('/educator/jobs');
      setJobs(data);
    }

    getData();
  }, []);

  const handleInputChange = (index) => (e) => {
    const updateFeedback = [...jobs];
    updateFeedback[index] = setFeedback(e.target.value);
  };

  async function handleSubmit(e, id, status) {
    // e.preventDefault();

    await api.put(`/educator/jobs/${id}`, { status, feedback });

    return toast.success('Feedback enviado com sucesso.');
  }

  return (
    <>
      <Header>
        <ButtonTest
          type="submit"
          onClick={() => history.push('/educatorChallenge')}
        >
          <h2>Desafios</h2>
        </ButtonTest>
        <ButtonTest
          type="submit"
          onClick={() => history.push('/educatorJobs')}
          selected
        >
          <h2>Vagas</h2>
        </ButtonTest>
        <ButtonTest
          type="submit"
          onClick={() => history.push('/educatorTutoria')}
        >
          <h2>Tutoria</h2>
        </ButtonTest>
        <ButtonTest
          type="submit"
          onClick={() => history.push('/educatorUsers')}
        >
          <h2>Usuários</h2>
        </ButtonTest>
      </Header>
      <Container>
        <h1>Vagas pendentes de Feedback: ({jobs.length})</h1>

        {jobs.map((job, index) => (
          <Row key={job.id}>
            <div className="main">
              <div>
                <p style={{ fontWeight: 'bold' }}>Detalhes da Vaga:</p>
                <p>Empresa: {job.job.company}</p>
                <p>
                  Titulo: {job.job.title} ({job.job.type_job})
                </p>
                <p>Local: {job.job.local}</p>
                <p>Trabalho remoto: {job.job.remote_job}</p>
                <p>Apollo Level: {job.job.apollo_level}</p>

                <Link
                  key={job.id}
                  to={`jobs/${job.job_id}`}
                  params={{ id: job.job_id }}
                >
                  <p style={{ marginTop: -20 }}>Ver Vaga</p>
                </Link>
              </div>
              <div>
                <p style={{ fontWeight: 'bold' }}>Detalhes do Candidato:</p>
                <p>
                  Nome Completo: {job.user.first_name} {job.user.last_name}{' '}
                </p>
                <p>
                  {' '}
                  Local: {job.user.city}/{job.user.state}{' '}
                </p>
                <p> Apollo Level: {job.user.apollo_level}</p>
                <p>Ingles: {job.user.english}</p>
                <p>Tempo programando: {job.user.level}</p>
                <Link to={`/userprofile/${job.user.id}`} target="_blank">
                  <p style={{ marginTop: -20 }}>Ver Perfil</p>
                </Link>
              </div>
            </div>
            <form>
              <textarea
                type="text"
                placeholder="Digite o feedback da resposta"
                value={feedback}
                onChange={handleInputChange(index)}
              />
              <button
                type="submit"
                className="correct"
                onClick={(e, status = 'approved') =>
                  handleSubmit(e, job.id, status)
                }
              >
                APROVADO
              </button>
              <button
                type="submit"
                className="wrong"
                onClick={(e, status = 'denied') =>
                  handleSubmit(e, job.id, status)
                }
              >
                NEGADO
              </button>
            </form>
          </Row>
        ))}
      </Container>
    </>
  );
}
